import { api } from "@/lib/axios";
import type {
  AuthResponse,
  CreateFirstAdminPayload,
  LoginCredentials,
  User,
} from "@/types";

export const authService = {
  async createFirstAdmin(
    payload: CreateFirstAdminPayload,
  ): Promise<AuthResponse> {
    const response = await api.post("/auth/create-first-admin", payload);
    return response.data;
  },

  async login(credentials: LoginCredentials): Promise<AuthResponse> {
    const response = await api.post("/auth/login", credentials);
    return response.data;
  },

  async logout(): Promise<void> {
    await api.post("/auth/logout");
  },

  async refresh(): Promise<void> {
    await api.post("/auth/refresh");
  },

  async getCurrentUser(): Promise<User> {
    const response = await api.get("/users/me");
    return response.data;
  },
};
